module.exports = __webpack_public_path__ + "logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 1851
// module chunks = 0